<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <g clip-path="url(#clip0_5536_10773)">
      <path d="M1 1L24 24" stroke="currentColor" />
      <path d="M24 1L1 24" stroke="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_5536_10773">
        <rect width="25" height="24.9996" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
